<script>
import { HorizontalBar, mixins } from 'vue-chartjs'
import { getStyle, hexToRgba } from '@coreui/coreui-pro/dist/js/coreui-utilities'
import { CustomTooltips } from '@coreui/coreui-plugin-chartjs-custom-tooltips'
import { random } from '@/shared/utils'
import moment from 'moment'

export default {
  extends: HorizontalBar,
  props: ['height', 'options', 'chartData', 'userData', 'channelData'],
  mixins: [mixins.reactiveProp],

  mounted () {
    var self = this
    let d = this.chartData;
    // console.log(d)

    const chartColorScheme = [
      '#20c997',  // teal
      '#17a2b8',  // cyan
      '#6f42c1',  // purple
      '#ffc107',  // brand warning (yellow)
      '#c8ced3',  // gray 300
      '#63c2de',  // brand secondary (light blue)
      '#6610f2',  // indigo
      '#73818f',  // gray 600

      '#52E3B8',  // teal 15% lighter
      '#94EED3',  // teal 30% lighter
      '#158765',  // teal 15% darker

      '#36CEE6',  // cyan 15% lighter
      '#7ADFEE',  // cyan 30% lighter
      '#117A8B',  // cyan 10% darker

      '#9B7CD4',  // purple 15% lighter
      '#C7B6E7',  // purple 30% lighter

      '#FFD454',  // yellow, 15% lighter
      '#FFE7A1',  // yellow, 30% lighter

      '#FF9807',  // orange
      '#FFAD3A',  // orange 10% lighter
    ]

    let xAxisLabels = []
    let chartDatasets = []

    // sort the names alphabetically.  Deffering for later
    // let cids = Object.keys(d)
    // let cidNames = []
    // for(const cid of cids) {
    //   let c = self.channelData.find(channel => channel.id == cid)
    //   if(c === undefined) {
    //     console.log('Could not find channel by ID: ' + cid)
    //     continue
    //   }
    //   cidNames.push([cid, c.name])
    // }

    // because of how chartjs does stacked charts, have to build a big list of all the user IDs first and maintain their order in each dataset.  fucking stupid.
    let allUserIds = []
    let userArrayPosMap = {}
    let channelArrayPosMap = {}
    let userChannelCounts = {}
    let maxValue = 0
    Object.keys(d).forEach(function(channelId, channelIndex) {
      let channel = self.channelData.find(channel => channel.id == channelId)
      xAxisLabels.push('#' + channel.name)

      channelArrayPosMap[channelId] = channelIndex

      let channelTotal = 0
      for(const row of d[channelId]) {
        channelTotal += row.mentions
        allUserIds.push(row.user_id)
      }
      if(channelTotal > maxValue) {
        maxValue = channelTotal
      }
    })
    allUserIds = [...new Set(allUserIds)]
    // console.log(allUserIds)
    let pos = 0
    for(const uid of allUserIds) {
      userArrayPosMap[uid] = pos
      pos++
    }
    // console.log(userArrayPosMap)

    for(const uid of allUserIds) {
      let user = self.userData.find(member => member.id == uid)

      let userData = {
        label: user.real_name,
        data: new Array(Object.keys(channelArrayPosMap).length).fill(0)
      }

      // need to get each channel's mention count into the correct position of userData.data
      for(const channelId of Object.keys(d)) {

        for(const row of d[channelId]) {
          if(row.user_id == uid) {
            userData.data.splice(channelArrayPosMap[channelId], 1, row.mentions)
          }
        }
      }

      chartDatasets.push(userData)
    }

    // set a good-looking max X axis value
    let xMax = maxValue  // Math.ceil(maxValue / 5) * 5;
    if(maxValue < 5) {
      xMax = 5
    } else if(maxValue < 10) {
      xMax = 10
    } else {
      xMax = Math.ceil(maxValue / 5) * 5;
    }



    this.renderChart({
      labels: xAxisLabels,
      datasets: chartDatasets
    }, 
    // chart options
    {
      
      maintainAspectRatio: false,
      legend: {
        display: true,
        position: 'bottom'
      },
      tooltips: {
        callbacks: {
          // filter out 0 values!
          label: function(tooltipItem, data) {
            let d = data.datasets[tooltipItem.datasetIndex]
            let v = d.data[tooltipItem.index]
            if(v == 0 || v === undefined) {
              return
            }
            return d.label + ': ' + v;
          }
        }
        // filter: function(tooltipItem, data) {
        //   console.log(tooltipItem)
        //   console.log(data)
        // }
      },
      scales: {
        xAxes: [{
          stacked: true,
          gridLines: {
            drawOnChartArea: false
          },
          ticks: {
            autoSkip: true,
            beginAtZero: true,
            precision: 0,
            max: xMax,
            maxTicksLimit: 24
          },
          scaleLabel: {
            display: true,
            labelString: '# of mentions'
          }
          
        }],
        yAxes: [{
          stacked: true,
          ticks: {
            beginAtZero: true,
          },
          gridLines: {
            display: true
          }
        }]
      },

      plugins: {
        colorschemes: {
          scheme: chartColorScheme
        }
      }

    })
        
  }
}
</script>
